module.exports = __webpack_public_path__ + "img/wp-new-habit-card22.47e9da7f.jpg";